<template>
  <HomepageFeatureSection
    title="Full financial visibility"
    body="See the full financial picture across all of your financial accounts."
    color="var(--colorSwissYellow300)"
  >
    <div class="HomepageAccountsFeatureSection__accountList">
      <FinancialAccountItem
        v-for="account in accounts"
        :key="account.DisplayName"
        :modelValue="account"
      />
    </div>
  </HomepageFeatureSection>
</template>

<script lang="ts" setup>
import FinancialAccountItem from "@cosine/components/FinancialAccountItem.vue";
import HomepageFeatureSection from "@cosine/components/homepage/HomepageFeatureSection.vue";
import useLiveTime from "@cosine/composables/useLiveTime";
import { createEnrichedFinancialAccount } from "@cosine/tests/factories/FinancialAccountFactory";
import { AccountType } from "@cosine/types/api-models";
import { subHours, subMinutes } from "date-fns";
import { computed } from "vue";

const {
  now,
} = useLiveTime();

const accounts = computed(() => {
  return [
    createEnrichedFinancialAccount({
      Type: AccountType.CreditCard,
      DisplayName: "Credit card",
      InstitutionName: "Visa",
      Nickname: "8827",
      Balance: 2090_01,
      SyncedAt: subHours(now.value, 4).toISOString(),
    }),
    createEnrichedFinancialAccount({
      Type: AccountType.Investment,
      DisplayName: "Investments",
      InstitutionName: "Robinhood",
      Nickname: "0378",
      Balance: 27228_19,
      SyncedAt: subMinutes(now.value, 1).toISOString(),
    }),
    createEnrichedFinancialAccount({
      Type: AccountType.Checking,
      DisplayName: "Checking",
      InstitutionName: "Chase",
      Nickname: "9189",
      Balance: 10846_44,
      SyncedAt: subHours(now.value, 6).toISOString(),
    }),
  ];
});
</script>

<style lang="scss" scoped>
.HomepageAccountsFeatureSection__accountList {
  display: grid;
}
</style>
